import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["popover", "trigger"];

  connect() {
    this.hideTimer = null;
    this.boundCloseIfOutside = this.closeIfOutside.bind(this);
    /** @type {"closed" | "hover" | "click"} */
    this.interactionMode = "closed";
  }

  disconnect() {
    this.clearHideTimer();
    document.removeEventListener("click", this.boundCloseIfOutside);
  }

  onMouseEnter() {
    this.clearHideTimer();
    if (!this.isOpen()) {
      this.open();
      this.interactionMode = "hover";
    }
  }

  onMouseLeave() {
    if (this.interactionMode === "hover") {
      this.hideTimer = window.setTimeout(() => this.close(), 200);
    }
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clearHideTimer();

    if (!this.isOpen()) {
      this.open();
      this.interactionMode = "click";
      document.addEventListener("click", this.boundCloseIfOutside);
      return;
    }

    if (this.interactionMode === "hover") {
      this.interactionMode = "click";
      document.addEventListener("click", this.boundCloseIfOutside);
      return;
    }

    this.close();
  }

  isOpen() {
    return !this.popoverTarget.hidden;
  }

  open() {
    this.clearHideTimer();
    this.popoverTarget.hidden = false;
    this.triggerTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    this.clearHideTimer();
    this.interactionMode = "closed";
    this.popoverTarget.hidden = true;
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.boundCloseIfOutside);
  }

  closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}
